import { getNetworkErrorMessage } from '@framework/auth';
import { useTranslation } from '@framework/i18n';
import { ButtonDeleteConfirm } from '@framework/ui';
import { message } from 'antd';
import React, { useCallback } from 'react';
import { useRemoveSubmissionManager } from '../hooks/useRemoveSubmissionManager';

export interface IRemoveSubmissionAttorneyButtonProps {
  submissionId: string | null;
  disabled?: boolean;
  iconOnly?: boolean;
}

export function RemoveSubmissionAttorneyButton(
  props: IRemoveSubmissionAttorneyButtonProps,
) {
  const { submissionId, disabled, iconOnly } = props;
  const { t } = useTranslation();
  const { remove } = useRemoveSubmissionManager();
  const handleRemove = useCallback(async () => {
    if (!submissionId) {
      console.error('No submissionId');
      return;
    }
    try {
      await remove.mutateAsync(submissionId);
      message.success(
        t(
          'remove-submission-attorney-button.procuratore-rimosso-con-successo',
          'Procuratore rimosso con successo',
        ),
      );
    } catch (e) {
      console.error(e);
      message.error(getNetworkErrorMessage(e, t("remove-submission-attorney-button.errore", 'Si è verificato un errore. Riprovare.'))); // prettier-ignore
    }
  }, [remove, submissionId, t]);
  return (
    <ButtonDeleteConfirm
      size="middle"
      tooltip={
        iconOnly
          ? t(
              'remove-submission-attorney-button.rimuovi-procuratore',
              'Rimuovi Procuratore',
            )
          : undefined
      }
      title={t(
        'remove-submission-attorney-button.rimuovere-attuale-procuratore',
        "Rimuovere l'attuale procuratore?",
      )}
      onConfirm={handleRemove}
      disabled={disabled}
      children={
        iconOnly
          ? null
          : t(
              'remove-submission-attorney-button.rimuovi-procuratore',
              'Rimuovi Procuratore',
            )
      }
      buttonType={iconOnly ? 'link' : 'default'}
      iconOnlyButton={iconOnly}
    />
  );
}
